"use strict";

import angular from "angular";
import { GetSignnUpDataUsecase } from "../../../usecases/get-signn-up-data.usecase";

angular.module("nucont.trials").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.signup-employee", {
        url: "ativacao-usuario/:accountingId/:userId",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-trials" */ "./employee-signup/employee-signup.component"
            ).then(() => $ocLazyLoad.inject("nucont.trials"));
        },
        views: {
            "main@": {
                component: "emptyLayoutComponent"
            },
            "empty@nucont.signup-employee": {
                component: "employeeSignupComponent"
            }
        },
        resolve: {
            signUpData: [
                "$state",
                "$stateParams",
                async ($state, $stateParams) => {
                    try {
                        const signUpData = await new GetSignnUpDataUsecase().execute(
                            {
                                _id: $stateParams.userId,
                                accountingId: $stateParams.accountingId
                            }
                        );
                        return signUpData;
                    } catch (err) {
                        return $state.go("nucont");
                    }
                }
            ]
        }
    });
}
